import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MovieCard from "./MovieCard";

export default function MovieRow({ title, label, movies, favoriteIds = [], onToggleList, variant = "editorial" }) {
  const ref = useRef(null);
  if (!movies || movies.length === 0) return null;

  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * ref.current.clientWidth * 0.85, behavior: "smooth" });
  };

  return (
    <section data-testid={`row-${label}`} className="relative space-y-4">
      <div className="flex items-end justify-between px-4 sm:px-8 lg:px-12">
        <div>
          <div className="font-mono-mini text-[11px] uppercase tracking-[0.4em] text-[color:var(--ns-accent)]">
            {label}
          </div>
          <h2 className="font-display text-2xl sm:text-3xl text-white uppercase tracking-tight">{title}</h2>
        </div>
        <div className="hidden sm:flex items-center gap-2">
          <button
            onClick={() => scroll(-1)}
            className="w-10 h-10 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 flex items-center justify-center transition"
            aria-label="Précédent"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={() => scroll(1)}
            className="w-10 h-10 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 flex items-center justify-center transition"
            aria-label="Suivant"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <div
        ref={ref}
        className="flex gap-5 overflow-x-auto px-4 sm:px-8 lg:px-12 pb-4 snap-x snap-mandatory"
        style={{ scrollbarWidth: "none" }}
      >
        {movies.map((m) => (
          <div
            key={m.id}
            className={`snap-start shrink-0 ${variant === "poster" ? "w-[180px] sm:w-[220px]" : "w-[320px] sm:w-[400px]"}`}
          >
            <MovieCard
              movie={m}
              inList={favoriteIds.includes(m.id)}
              onToggleList={onToggleList}
              variant={variant}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
